export class coach{
  programCode: String = "";  
  programTitle: String = "";
  programDesc: String = "";

  sumAccess: String = "3401520";
  sumName: String = "";
  sumRisk: String = "";

  coachDate: string = "";
  attendance: string = "";
  user_id: string = "";
  activity_mins: string = "";
  weight: string = "";
  
}
